/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Schoolvakanties_BronInputs */

const nl_planning_vakanties_schoolvakanties_bron = /** @type {(inputs: Planning_Vakanties_Schoolvakanties_BronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`van de Rijksoverheid`)
};

/**

* @param {Planning_Vakanties_Schoolvakanties_BronInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_schoolvakanties_bron = /** @type {((inputs?: Planning_Vakanties_Schoolvakanties_BronInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Schoolvakanties_BronInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_schoolvakanties_bron(inputs)
});
export { planning_vakanties_schoolvakanties_bron as "planning.vakanties.schoolvakanties_bron" }